import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  NbMediaBreakpointsService,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
} from "@nebular/theme";

import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { LayoutService } from "../../../@core/utils/layout.service";
import { DOCUMENT } from "@angular/common";
import {
  SharedService,
  StudyYear,
  StudyYearObject,
} from "../../../root-services/shared.service";
import { UserService } from "../../../pages/services/users.service";
import { User } from "../../../pages/models/users";
import { ToasterService } from "../../../root-services/toaster.service";

@Component({
  selector: "ngx-header",
  styleUrls: ["./header.component.scss"],
  templateUrl: "./header.component.html",
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  selectedStudyYear: StudyYear;
  arabicPrivileges = {
    as: "معاون",
    o: "مدير",
    a: "محاسب",
    ins: "أستاذ/ة",
    inf: "إستعلامات",
    dv: "سائق"
  };
  user: User;

  themes = [
    {
      value: "default",
      name: "فاتح",
    },
    {
      value: "cosmic",
      name: "بنفسجي",
    },
    {
      value: "orange-theme",
      name: "عملي",
    }
  ];
  fullScreen = false;
  currentTheme = "default";
  studyYear: StudyYearObject;
  userMenu = [{ title: "Profile" }, { title: "Log out" }];
  elem;
  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private sharedService: SharedService,
    private userService: UserService,
    private toaster: ToasterService,
    @Inject(DOCUMENT) private document: any
  ) {}

  ngOnInit() {
    this.checkIfFullScreen();
    this.themeSetup();
    this.getUser();
    this.getStudyYearandYears();
  }

  getStudyYearandYears() {
    this.sharedService.getstudyYear.subscribe((year) => {
      this.studyYear = undefined;
      if (year?.selectedStudyYear?.id) {
        this.studyYear = year;
      }
    });
  }

  changeStudyYear(event: StudyYear) {
    this.studyYear.selectedStudyYear = event;
    this.sharedService.setStudyYear(this.studyYear);
    this.toaster.showToast();
  }
  getUser() {
    this.user = this.sharedService.getUser();
  }
  checkIfFullScreen() {
    this.elem = document.documentElement;
    if (
      document.fullscreenElement /* Standard syntax */ ||
      document["webkitFullscreenElement"] /* Safari and Opera syntax */ ||
      document["msFullscreenElement"] /* IE11 syntax */
    ) {
      this.fullScreen = true;
    }
  }
  themeSetup() {
    this.currentTheme = this.themeService.currentTheme;

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (isLessThanXl: boolean) => (this.userPictureOnly = isLessThanXl)
      );

    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$)
      )
      .subscribe((themeName) => (this.currentTheme = themeName));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    localStorage.setItem("theme", themeName);
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, "menu-sidebar");
    this.layoutService.changeLayoutSize();

    return false;
  }
  toggleFullScreen() {
    if (!this.fullScreen) this.openFullscreen();
    else this.closeFullscreen();
  }
  openFullscreen() {
    this.fullScreen = true;
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  /* Close fullscreen */
  closeFullscreen() {
    this.fullScreen = false;
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }
  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
}
